class Accordion {

    constructor() {
        this.accordion = $('#accordion');

        if (this.accordion.length) {
            this.toggles = $('[data-toggle=collapse]');
            this.preventDesktop();
        }

    }

    preventDesktop() {

        if (this.accordion.hasClass('no-desktop') && window.innerWidth >= 1024) {
            this.toggles.prop('disabled', true);

            this.toggles.on('click', event => this.preventAnchorClick(event));
            return;
        }

    }

    preventAnchorClick(e) {
        e.preventDefault();
        return;
    }

}
//Fix for accordion, so it will open and close 
var accordionHeaders = document.querySelectorAll(".accordion-header");
var openAccordion = null;

accordionHeaders.forEach((header) => {
    header.addEventListener("click", () => {
        var accordionBody = header.nextElementSibling;
        var icon = header.querySelector(".icon-plus");

        if (accordionBody.style.display === "none" || accordionBody.style.display === "") {
            accordionBody.style.display = "block";
            icon.style.transform = "translateY(-50%) rotate(45deg)";

            if (openAccordion && openAccordion !== accordionBody) {
                openAccordion.style.display = "none";
                var openAccordionIcon = openAccordion.previousElementSibling.querySelector(".icon-plus");
                openAccordionIcon.style.transform = "translateY(-50%)";
            }

            openAccordion = accordionBody;
        } else {
            accordionBody.style.display = "none";
            icon.style.transform = "translateY(-50%)";

            openAccordion = null;
        }
    });
});

export default Accordion;